import { Component, OnInit, ViewChild, AfterViewInit } from '@angular/core';
import { Subject } from 'rxjs';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { AppInformationService, BrewersUnitOfWork } from '../../core/core.module';
import _ from 'lodash';
import { confirm, alert } from 'devextreme/ui/dialog';

@Component({
    standalone: false,
    selector: 'app-input-dialog',
    templateUrl: './input-dialog.component.html',
    styleUrls: ['./input-dialog.component.scss'],
})
export class InputDialogComponent implements OnInit, AfterViewInit {
    result = new Subject<{ success: boolean, value?: any }>();
    dialogHeader: string;
    dialogPrompt: string;
    dialogMessage: string;
    dialogValue: any;
    dialogValueArray: any[];
    defaultValue: any;
    checkNumeric: boolean;
    checkInteger: boolean;
    minValue: number = null;
    mode: 'text' | 'password' | 'textarea' | 'select' | 'selectWithId' | 'date' = 'text';
    saveAndNewVisible = false;
    autoSaveIfNotEmpty = false;
    autoSaveInterval: any;
    previousValue: any;
    valueExpr = 'id';
    displayExpr = 'name';
    processing = false;

    @ViewChild('inputComponent') inputComponent: any;

    constructor(public modalRef: BsModalRef, private uow: BrewersUnitOfWork, private appInfo: AppInformationService) {}

    async ngOnInit() {}

    checkInput() {
        if (this.dialogValue !== undefined && this.dialogValue.length > 0 && this.dialogValue !== this.previousValue) {
            this.previousValue = this.dialogValue;
        } else if (this.dialogValue !== undefined && this.dialogValue.length > 0 && this.dialogValue === this.previousValue) {
            clearInterval(this.autoSaveInterval);
            this.save();
        }
    }

    ngAfterViewInit() {
        setTimeout(() => {
            this.inputComponent.instance.focus();
        });
        if (this.autoSaveIfNotEmpty) {
            this.autoSaveInterval = setInterval(() => {
                this.checkInput();
            }, 500);
        }
    }

    onInput(e: any) {}

    enterPressed() {
        if (this.mode !== 'textarea') this.save();
    }

    save(andNew?: boolean) {
        if (this.checkNumeric && isNaN(this.dialogValue)) {
            alert('Value needs to be a number', `${this.appInfo.settings.company}`);
            return;
        }
        if (this.checkInteger && (isNaN(this.dialogValue) || Number(this.dialogValue) !== Math.round(Number(this.dialogValue)))) {
            alert('Value needs to be an integer', `${this.appInfo.settings.company}`);
            return;
        }
        if (this.minValue != null && Number(this.dialogValue) < Number(this.minValue)) {
            alert(`Value needs to be greater than or equal to ${this.minValue}`, `${this.appInfo.settings.company}`);
            return;
        }
        if (andNew) {
            //
        } else {
            this.processing = true;
            this.result.next({ success: true, value: this.dialogValue });
        }
    }

    cancel() {
        this.result.next({ success: false });
    }
}
